export function getActionById(actions, id) {
    for (const action of actions) {
        if (action.id === id) {
            return action;
        }
        if (action.actions) {
            const child = getActionById(action.actions, id);
            if (child) {
                return child;
            }
        }
    }
    return null;
}